/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/*
* Block compatibility check functions

// --------------- How to use it: ----------------
In the block definitions, call appropriate functions and define the type of connection in setPreviousStatement() statement
this.setPreviousStatement(true, 'type_of_this_block')
this.setNextStatement(true, getAllowedOutputs('type_of_this_block'))
this.appendStatementInput()
    .setCheck(getAllowedStatement('type_of_this_block'))
*/

// Next Statement
function getAllowedOutputs(type) {

    var array_Options = {  
        'environmental_indicators': ['strata_environment_indicator'],

        'conflict_indicators': ['strata_conflict_indicator'],

        'vulnerability_indicators': ['strata_vulnerability_indicator'],

        'strata_convergence_output': ['strata_calculate_stress'],

        'strata_calculate_stress': ['strata_update_dashboard', 'strata_dashboard_viz'],

        'strata_predictive_outputs' : ['strata_predictive_dashboard', 'strata_calculate_stress']


    };

    return array_Options[type];
}

// Statement Input
function getAllowedStatements(type) {

    var array_Options = {

        'environmental_indicators': ['strata_environment_indicator'],

        'conflict_indicators': ['strata_conflict_indicator'],

        'vulnerability_indicators': ['strata_vulnerability_indicator'],

        'strata_convergence_output': ['strata_calculate_stress'],

        'strata_bitmap_output': ['strata_dashboard_viz'],

        'predictive_indicators': ['predictive_indicators'],

        'predictive_convergence': ['strata_predictive_convergence'],

        'strata_predictive_outputs': ['strata_predictive_outputs']
        

    };

    return array_Options[type];
}
export { getAllowedOutputs, getAllowedStatements };
